import "./GoToPortalButton.scss";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FCC } from "types";

import UserIcon from "@/assets/icons/User.svg?react";

export const GoToPortalButton: FCC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("portal");

  const goToWelcome = () => {
    navigate("/welcome");
  };

  return (
    <button
      data-testid="portal-button"
      className="header-portal-button"
      onClick={goToWelcome}
    >
      <span className="portal-text">{t("layout.header.menu.portal")}</span>
      <div className="home-icon">
        <UserIcon />
      </div>
    </button>
  );
};
